import { ArrowDown2 } from 'iconsax-react';
import PropTypes from 'prop-types';
import * as styles from './styles';

export default function Arrow({ show, func, size = 24, color }) {
  return (
    <styles.Container $show={show}>
      <button type="button" onClick={func}>
        <ArrowDown2 size={size} color={color} />
      </button>
    </styles.Container>
  );
}

Arrow.propTypes = {
  show: PropTypes.bool.isRequired,
  func: PropTypes.func.isRequired,
  color: PropTypes.node.isRequired,
  size: PropTypes.number,
};
